import type { Filter, FilterNode } from '@outreach/contracts';

export interface SegmentConditions {
  hasEmail: boolean;
  emailConsent: boolean;
  tagId?: string;
}

/**
 * Build a filter AST from the simple segment builder. Returns null when no
 * condition is selected (an empty group would be rejected by the contract). The
 * produced shape must match `filterSchema` in @outreach/contracts.
 */
export function buildSegmentFilter(c: SegmentConditions): Filter | null {
  const nodes: FilterNode[] = [];
  if (c.hasEmail) nodes.push({ type: 'has_email' });
  if (c.emailConsent) nodes.push({ type: 'channel_consent', channel: 'email', positive: true });
  if (c.tagId) nodes.push({ type: 'tag', tagId: c.tagId });
  if (nodes.length === 0) return null;
  return { version: 1, node: { type: 'all', nodes } };
}
